import Vue from 'vue'

// 全局注册指令

/* 这个增强版的自定义指令 v-remove-class-on-visible 实现了以下功能：

使用 MutationObserver 监听元素的 style 属性变化

当检测到 style 属性变化时，检查 visibility 的计算值

如果 visibility 变为 'visible'，则从 data-wow-duration 属性中获取延迟时间

在指定的延迟时间后移除元素的所有类名

支持多种时间格式：秒（2s）、毫秒（500ms）或纯数字（默认为秒）

在指令解绑时清理 MutationObserver 以防止内存泄漏 */
Vue.directive('remove-class-on-visible', {
	bind: function(el, binding, vnode) {
		// 创建 MutationObserver 监听 style 属性变化
		const observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
					const visibility = window.getComputedStyle(el).visibility;
					if (visibility === 'visible') {
						// 获取延迟时间
						const durationAttr = el.getAttribute('data-wow-duration');
						let delay = 0;

						if (durationAttr) {
							// 解析时间字符串，支持 '2s', '1.5s', '500ms' 等格式
							if (durationAttr.endsWith('ms')) {
								delay = parseFloat(durationAttr) / 1000;
							} else if (durationAttr.endsWith('s')) {
								delay = parseFloat(durationAttr);
							} else {
								// 默认单位为秒
								delay = parseFloat(durationAttr);
							}
						}

						// 设置定时器，在延迟后移除所有类
						setTimeout(() => {
							el.className = '';
						}, delay * 1000);
					}
				}
			});
		});

		// 开始观察
		observer.observe(el, {
			attributes: true,
			attributeFilter: ['style']
		});

		// 将 observer 存储在元素上，以便在 unbind 时使用
		el._visibilityObserver = observer;
	},

	unbind: function(el) {
		// 清理 observer
		if (el._visibilityObserver) {
			el._visibilityObserver.disconnect();
		}
	}
});

// input限制长度
Vue.directive('maxlength', {
	bind(el, binding, vnode) {
		const input = el.querySelector('input');
		input.addEventListener('input', function() {
			if (this.value.length > binding.value) {
				this.value = this.value.slice(0, binding.value);
				vnode.componentInstance.$emit('input', this.value);
			}
		});
	}
});

// 转换px为rem
Vue.directive('rem', {
	inserted(el) {
		const walk = (node) => {
			if (node.style) {
				const style = node.getAttribute('style');
				if (style && style.includes('px')) {
					node.setAttribute('style',
						style.replace(/(\d+)px/g, (m, p1) => `${p1 / 144}rem`));
				}
			}

			if (node.children) {
				Array.from(node.children).forEach(walk);
			}
		};

		walk(el);
	}
});

// 鼠标进入/离开元素切换某项类名
Vue.directive('toggle-class', {
	bind(el, binding) {
		// 确保传入的参数是有效的
		if (!binding.value) {
			console.warn('v-toggle-class requires a class name as value');
			return;
		}

		const className = binding.value;
		let hasClass = el.classList.contains(className);

		// 鼠标移入事件处理
		el.__mouseEnterHandler__ = function() {
			el.classList.remove(className);
		};

		// 鼠标移出事件处理
		el.__mouseLeaveHandler__ = function() {
			if (!el.classList.contains(className)) {
				el.classList.add(className);
			}
		};

		// 添加事件监听
		el.addEventListener('mouseenter', el.__mouseEnterHandler__);
		el.addEventListener('mouseleave', el.__mouseLeaveHandler__);
	},

	unbind(el) {
		// 移除事件监听
		el.removeEventListener('mouseenter', el.__mouseEnterHandler__);
		el.removeEventListener('mouseleave', el.__mouseLeaveHandler__);

		// 删除自定义属性
		delete el.__mouseEnterHandler__;
		delete el.__mouseLeaveHandler__;
	}
});